const tabs = {
  nuevo: [
    'WildTiger',
    'BurningChilliX',
    'HotChilliBells',
  ],
  popular: [
    'WildTiger',
    'JokersMillion',
    'AztecMagicMegaways',
    'HotChilliBells',
    'BurningChilliX',
    'BonanzaBillion',
    'JokerQueen',
    'SnoopDoggDollars',
    'WildWestTrueways',
    'FruitMillion',
  ],
};

export function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}